import { render } from "./QrCode.vue?vue&type=template&id=99ff0906&scoped=true"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"

import "./QrCode.vue?vue&type=style&index=0&id=99ff0906&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99ff0906"]])

export default __exports__